module.exports = __webpack_public_path__ + "assets/51c6be25d73c59b45aafd62b6e1d10e7.png";